import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function MudjackingIcon(props) {
	return (
		<IconBase type="mudjacking" {...props}>
			<path d="M8.5 15.5L9.205 16.205L11.5 13.915V19H12.5V13.915L14.795 16.21L15.5 15.5L12 12L8.5 15.5Z" />
			<path d="M21 5H3V10.2979L5.04064 10.0258L7.5066 10.7656L10.2486 10.0178L13.9318 11H13.9742L16.2242 10L18.5 10.7586L20.7039 10.024L21 10.0663V5Z" />
		</IconBase>
	);
}
MudjackingIcon.propTypes = iconPropTypes;
